import { IMessageBusOptions } from '../plugin';
import { MessageBusTransportType } from './enums';
import { EventEnvelop, EventEnvelopData, EventKey } from './event-sourcing';
import { MessageBusTransportHttp } from './message-bus-transport-http';
import { IMessageBusTransport } from './models';

export class MessageBus {

    private static __instance: MessageBus;
    private transport: IMessageBusTransport;
    private account: string;
    private clientId: string;

    protected constructor() {
    }

    async setup(options: IMessageBusOptions): Promise<void> {
        switch (options.transport.type) {
            case MessageBusTransportType.SignalR:
            case MessageBusTransportType.Http:
            default:
                this.transport = new MessageBusTransportHttp();
        }
        this.clientId = options.clientId;
        this.account = options.account;
        await this.transport.setup(options.transport);
    }

    async queue(aggregateName: string, aggregateId: string, type: EventKey, data: EventEnvelopData = {}, metadata = {}): Promise<boolean> {
        const e: EventEnvelop = this.createEvent(aggregateName, aggregateId, type, data, metadata);
        return await this.transport.append([e]);
    }

    async send(aggregateName: string, aggregateId: string, type: EventKey, data: EventEnvelopData = {}, metadata = {}): Promise<boolean> {
        const e: EventEnvelop = this.createEvent(aggregateName, aggregateId, type, data, metadata);
        return this.transport.send([e]);
    }

    async flush(forced: boolean = false): Promise<void> {
        await this.transport.commit(forced);
    }

    async flushAll(): Promise<void> {
        await this.transport.sendAll();
    }

    private createEvent(aggregateName: string, aggregateId: string, type: EventKey, data: EventEnvelopData = {}, metadata = {}): EventEnvelop {
        if (!aggregateName) {
            throw new Error('Events must have an aggregate type name');
        }
        if (!aggregateId) {
            throw new Error('The aggregate Id cannot be omitted');
        }
        if (!type) {
            throw new Error('Events must have a type');
        }
        let event: EventEnvelop = new EventEnvelop(type, data);
        // event.context.user.accountCode = this.account;
        // event.context.client.id = this.clientId;
        metadata = metadata || {};
        event.context = {
            ...event.context,
            ...metadata,
        };
        return event;
    }

    static GetInstance(): MessageBus {
        if (MessageBus.__instance === null) {
            MessageBus.__instance = new MessageBus();
        }
        return MessageBus.__instance;
    }

}
